import Modal from "@/views/zhiji/components/modals/Modal";
import StmtMgmtPane from "@/views/statement/components/stmtMgmtPane";

export default {
    name: "StatementWrapper",
    components: {
        Modal,
        StmtMgmtPane
    }
};
